import { toLower, includes } from 'ramda';
import { OpenGraphType, Paywall, MetaProps } from './entities';

export type SeoProps = MetaProps & { paywall?: Paywall };

export const defaultImage = '/next-assets/images/benzinga-schema-image-default.png';

export const extractSeoMeta = async (props: SeoProps = {} as SeoProps) => {
  let { ogDescription, ogImage, ogTitle, ogType, title, twitterDescription, twitterImage, twitterTitle } = props;

  title = title?.substring(0, 105) || 'Benzinga - Actionable Trading Ideas, Real-Time News, Financial Insight';
  ogDescription = ogDescription ?? props.description;
  ogImage = ogImage || defaultImage;
  ogTitle = ogTitle ?? title;
  ogType = ogType ?? ('website' as OpenGraphType);
  twitterDescription = twitterDescription ?? props.description;
  twitterImage = twitterImage || props.image;
  twitterTitle = twitterTitle ?? title;

  if (!includes('benzinga', toLower(title))) {
    title = `${title} - Benzinga`;
  }

  const hreflangAlternates = props?.translationMeta
    ? Object.entries(props.translationMeta).reduce<Record<string, string>>((acc, [key, value]) => {
        if (value.url) {
          acc[key.replace('_', '-')] = value.url; // Converts "en_US" → "en-US"
        }
        return acc;
      }, {})
    : {};

  return {
    author: props.author,
    canonical: props.canonical,
    description: props.description,
    hrefLanguage: props.hrefLanguage,
    hreflangAlternates,
    image: props.image,
    ogDescription,
    ogImage,
    ogImageHeight: props.ogImageHeight ?? 630,
    ogImageWidth: props.ogImageWidth ?? 1200,
    ogTitle,
    ogType,
    robots: props.robots,
    shortUrl: props.shortUrl,
    symbol: props.symbol,
    title,
    translationMeta: props.translationMeta,
    twitterCard: props.twitterCard,
    twitterDescription,
    twitterImage,
    twitterTitle,
  };
};

export type ExtractedSeoMeta = ReturnType<typeof extractSeoMeta>;

export const decodeDescription = (text: string) => {
  // return text ? decode(text) : '';
  return text ?? '';
};

export const formatStringToValidJsonString = (text: string) => {
  return text
    .replace(/<[^>]*>?/g, '') // Remove HTML tags
    .replace(/&nbsp;/g, ' ') // Replace &nbsp; with space
    .replace(/&#8216;/g, "'") // Opening single quote
    .replace(/&#8217;/g, "'") // Closing single quote
    .replace(/&#8220;/g, '"') // Opening double quote
    .replace(/&#8221;/g, '"') // Closing double quote
    .replace(/\n/g, ' ');
};
